import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SelectWithTokensSelectListItem from './SelectWithTokensSelectListItem';

const SelectWithTokensSelectList = ({ selectWithTokensManager }) => {
    const { i18n } = useTranslation();
    const [itemsListIsChanged, setItemsListIsChanged] = useState(false);

    const changeItemsList = () => {
        setItemsListIsChanged(prev => !prev);
    };

    useEffect(() => {
        selectWithTokensManager.registerItemsChangingObserver(changeItemsList);
        return () => selectWithTokensManager.registerItemsChangingObserver(changeItemsList);
    }, [selectWithTokensManager]);

    return (
        <ul>
            <div className="scroll product__forms-container">
                {selectWithTokensManager.getPossibleItems().length ? 
                    selectWithTokensManager.getPossibleItems().map(it => (
                        <React.Fragment key={it.itemId + 'possible' + itemsListIsChanged}>
                            <SelectWithTokensSelectListItem selectWithTokensManager={selectWithTokensManager}
                                selectItem={{...it}} />
                        </React.Fragment>
                    ))
                    :
                    <li className="block__content product__forms-option">{i18n.t("app.page.product.notFound")}</li>
                }
            </div>
        </ul> 
    );
};

export default SelectWithTokensSelectList;
